import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";

import {
  DataCollectionApi,
  EmploymentStatusRequest,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitEmployment = createAsyncThunk<
  EmploymentStatusRequest,
  EmploymentStatusRequest,
  ThunkApi
>("submitEmployment", async (args, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addEmploymentStatus(args);

    return args;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio occupazione lavorativa",
      description:
        "Non siamo riusciti a salvare la tua occupazione lavorativa.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
